import { Typography } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { CSSProperties } from "react";

/**
 * @description Elemento botão para fazer o download de algo, tamanho do objeto se adapta ao texto colocado
 */
export default function DownloadModelButton ({ style, text, onClick }: { style?: CSSProperties, text?: string, onClick: Function }) {
    return (
        <div onClick={() => onClick()} style={{ borderRadius: '10px', margin: '8px 0px', height: '36px', width: 'auto', display: 'flex', background: 'var(--color-blue)', justifyContent: 'center', alignItems: 'center', borderWidth: '2px', cursor: 'pointer', color: 'var(--color-white)', ...style }}>
            <DownloadIcon style={{ margin: '0px 15px 0px 25px', fontSize: '20px' }} />
            <Typography style={{ margin: '0px 25px 0px 0px' }} fontSize={16}> {text ? text : 'Download Modelo'}</Typography>
        </div>
    )
}